var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14704 5.8914L2.64704 4.19909C2.32552 4.10016 2 4.34058 2 4.67698V19.1307C2 19.3502 2.14316 19.544 2.35296 19.6086L7.85296 21.3009C8.17448 21.3998 8.5 21.1594 8.5 20.823V6.36929C8.5 6.14978 8.35684 5.95595 8.14704 5.8914Z",
    fill: "#475A66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 3.42759L10.2519 5.85603C10.0961 5.94506 10 6.11072 10 6.29013V20.6383C10 21.0222 10.4148 21.2629 10.7481 21.0724L14.9969 18.644C15.1527 18.5549 15.2488 18.3893 15.2488 18.2099V3.86169C15.2488 3.47775 14.834 3.23707 14.5007 3.42759Z",
    fill: "#475A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 17.6615V3.30902C16.8 2.93733 17.1911 2.69558 17.5236 2.8618L21.5236 4.8618C21.693 4.9465 21.8 5.11963 21.8 5.30902V19.2615C21.8 19.6152 21.4427 19.8571 21.1143 19.7257L17.1143 18.1257C16.9245 18.0498 16.8 17.8659 16.8 17.6615Z",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/map_active.c5063618480b7e7bddb050c2fdbe80fd.svg";
export { ForwardRef as ReactComponent };